import {
    InitClient,
    GetByParas,
    Post,
    PostWithParas,
  } from "../ZeusAPIClient.js";
  import { apiConfig } from "../../config.js";
  InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

  //获取服务窗口
  async function GetOrderSerivceWin()
  {
      var paras={};
      return await GetByParas("59fa5209-f135-4498-be65-e6b6fe61ae5e",paras);
  }
  async function GetOrderServiceWinPage(id,pageIndex,pageSize)
  {
      var paras={ID:id,pageIndex:pageIndex,pageSize:pageSize}
      return await Post("2820b067-1293-4fcd-9af8-297686d75ddd",paras);
  }
  //增加一个服务窗口
  async function OrderServiceWinAdd(serviceWin)
  {
      return await Post("c65f0386-fd53-42ae-9c12-87cf8d396867",serviceWin)
  }
  async function UpdateServiceWin(serviceWin)
  {
      return await Post("34882b71-0420-4d34-abc7-d7db58680462",serviceWin);
  }
  async function DeleteServiceWin(ids)
  {
      var paras={ids:ids}
      return await GetByParas("ea40debc-efd0-4b6f-a586-6a26d7e276c6",paras);
  }
  //根据服务窗口获取预设问题列表
  async function GetOrderDefaultProblem(id)
  {
      var paras={
        orderServiceWinID:id
      }
      return await GetByParas("62b64afd-e11e-4d17-aad2-966cd4b1d3e3",paras)
  }
  async function GetOrderDefaultProblemPage(id,pageIndex,pageSize)
  {
      var paras={ID:id,pageIndex:pageIndex,pageSize:pageSize}
      return await Post("98e353d1-f550-4a96-9b9b-3bd30dbf72ab",paras);
  }
  //增加一个预设问题
  async function OrderDefaultProblemAdd(defaultProblem)
  {
      return await Post("89dc421b-a391-4dbe-8fab-85d510c52f61",defaultProblem);
  }
  //删除一个预设问题
  async function DeleteOrderDefaultProblem(ids)
  {
      var paras={
          ids:ids
      }
      return await GetByParas("ab1e5c2f-3674-4667-ad80-0c76436b8569",paras)
  }
  //更新一个问题
  async function UpdateOrderDefaultProblem(problem)
  {
      return await Post("ed653c9e-4ea5-4a97-b8a4-4e6a353c8286",problem)
  }
  //新增一条工单
  async function OrderDetailsAdd(orderDetail)
  {
      return await Post("53a111d9-442b-471e-9c57-6f2a92007107",orderDetail)
  }
  //获取聊天内容
  async function GetOrderRecord(id)
  {
      var paras={
        OrderDetailsID:id
      }
      return await GetByParas("df3262f0-1004-4372-b6f0-3a591668ff6d",paras)
  }
  //新增一条聊天
  async function OrderRecordAdd(orderRecord)
  {
      return await Post("90311750-7557-4acf-9551-6df5885ef67e",orderRecord);
  } 
  //根据Id获取一条预设问题数据
  async function GetOrderDefaultProblemItem(id)
  {
      var paras={
          ID:id
      }
      return await Post("ae567bbb-64c5-425e-98fc-624ce326bff1",paras);
  }
  async function UpdateOrderDetailRate(id,OrderState,Evaluation)
  {
      var paras={ID:id,OrderState:OrderState,Evaluation:Evaluation};
      return await Post("211f6b9c-c262-47af-aa46-cb61b8def5db",paras);
  }
  //根据发起人，工单状态获取工单list
  async function GetMyOrderDetailsList(orderServiceWin)
  {
      return await Post("804ae928-c74c-4bf1-9a2c-ec42c695551a",orderServiceWin);
  }
   //根据接单人，工单状态获取工单list
   async function GetMyOrderDetailsListByDeal(userid,state)
   {
       
       var paras={DealPersonEntID:userid,OrderState:state}
       return await GetByParas("5d351867-26f9-47e5-86d1-b43c1386a541",paras);
   }
  //根据ID获取工单详情
  async function GetOrderDetailsItem(id)
  {
      var paras={
          ID:id
      }
      return await GetByParas("6e7d4c11-ac12-4516-846f-36f978de2ba5",paras)
  }
  //把工单更新成处理中（抢工单）
  async function OrderDetailsUpdateOn(id,userid)
  {
      var paras={
          ID:id,
          DealPersonEntID:userid
      }
      return PostWithParas("d4ab9569-0659-46d3-824f-8c93a330b7f5",paras,{});
  }
  //把工单ID更新成已完成（结束工单）
  async function OrderDetailsUpdateEnd(id)
  {
      var paras={
          ID:id
      }
      return PostWithParas("6293c01d-e966-44cb-91e8-069542e08786",paras,{})
  }
  //通过ID删除聊天数据
  async function OrderRecordDelete(id)
  {
      var paras={
          ID:id
      }
      return GetByParas("4811156e-5b7d-4f03-aa71-055b188ec019",paras)
  }
  export{
    OrderRecordDelete,
    OrderDetailsUpdateEnd,
    OrderDetailsUpdateOn,
    GetOrderDetailsItem,
    GetMyOrderDetailsList,
    GetOrderDefaultProblemItem,
    OrderRecordAdd,
    GetOrderRecord,
    OrderDetailsAdd,
    OrderDefaultProblemAdd,
    GetOrderDefaultProblem,
    OrderServiceWinAdd,
    GetOrderSerivceWin,
    GetMyOrderDetailsListByDeal,
    UpdateServiceWin,
    DeleteServiceWin,
    GetOrderServiceWinPage,
    GetOrderDefaultProblemPage,
    DeleteOrderDefaultProblem,
    UpdateOrderDefaultProblem,
    UpdateOrderDetailRate
  }